module.exports = __webpack_public_path__ + "static/logo-ac28497b4d49ba3b3eb74ebb05a55aa1.png";